import React, { Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
  FeatureCard,
  Stats,
} from "../components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import Lottie from "react-lottie";
import { Collage, Features, OurProcess, YouWillGet } from "./Sections";

export default function Staff() {
  useEffect(() => {}, []);

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay2"></div>

        <img
          src={require("../img/11.jpg")}
          className="imgback"
          style={{ height: "80%" }}
        />
        <div
          className="content"
          style={{
            position: "absolute",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              width: "75vw",
            }}
          >
            <div
              style={{
                paddingTop: state.auth.isMobile ? "100px" : "0px",
                fontSize: state.auth.isMobile ? "60px" : "75px",
                color: "white",
                zIndex: 999,
                fontWeight: 600,
                textAlign: state.auth.isMobile ? "left" : "center",
              }}
            >
              Staff Augmentation
            </div>

            <div
              style={{
                borderBottom: "2px solid white",
                width: "100%",
                margin: "50px 0px 50px 0px",
                zIndex: 999,
              }}
            ></div>
            <div
              style={{
                fontSize: state.auth.isMobile ? "30px" : "40px",
                color: "white",
                zIndex: 999,
                textAlign: state.auth.isMobile ? "left" : "center",
              }}
            >
              Empower Your Team, Elevate Your Outcomes
            </div>
          </div>
        </div>
        <div style={{ height: "100vh" }}></div>
        <div style={{ height: "100px" }}></div>

        <ContentSideBySideInv
          title="Accelerate Projects with Expert Staff Augmentation"
          subtitle={
            <div>
              Staff augmentation has become a key strategy for businesses
              looking to scale quickly and efficiently. However, many
              organizations face challenges in finding the right talent,
              integrating them seamlessly, and ensuring they deliver value
              aligned with business goals. Our Staff Augmentation Services offer
              a comprehensive solution to bridge skill gaps, enhance team
              capabilities, and drive project success.
            </div>
          }
          image={
            <img style={{ width: "100%" }} src={require("../img/333.jpg")} />
          }
        />
        <ContentSideBySideInv
          title="Key Benefits of Staff Augmentation for Your Business"
          subtitle={
            <div style={{ marginLeft: "15px" }}>
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "orange",
                    marginRight: "15px",
                  }}
                />
                Flexibility
              </div>
              Businesses can scale their workforce up or down based on project needs, ensuring they have the right talent at the right time.
              <br />
              <br />
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "blue",
                    marginRight: "15px",
                  }}
                />
                Cost-Effectiveness
              </div>
              It reduces costs associated with full-time employment, such as benefits and long-term commitments.
              <br />
              <br />
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "teal",
                    marginRight: "15px",
                  }}
                />
               Access to Specialized Skills
              </div>
              Companies can quickly bring in experts with specialized skills that may not be available in-house.
            </div>
          }
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/marketing (6).json"), // Update animation file
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />
        <Features
          features={[
            "Scale your lineup as needed",
            "Get our devs on your team(s)",
            "Get an entire team working",
            "Manage the team yourself",
            "Leave project management to us",
          ]}
          plans={[
            {
              name: "Staff Augmentation",
              price: "$99/month",
              features: [true, true, true, true, true], // All features enabled
            },
            {
              name: "Dedicated Teams",
              price: "$69/month",
              features: [true, true, false, true, false], // Some features enabled
            },
            {
              name: "Outsourcing",
              price: "$29/month",
              features: [true, false, false, false, false], // Few features enabled
            },
          ]}
        />
        <SpacerV height={"100px"} />
        <SpacerV height={"100px"} />
        <ThreeSideBySide
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          spacing={5}
          subtitle1={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"On-Demand Talent Acquisition"}
                text={
                  "Quickly onboard skilled professionals tailored to your project needs. Our staff augmentation services provide access to top-tier talent, ensuring your team has the expertise required to deliver exceptional results."
                }
                icon={
                  <TravelExploreIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"Flexible Team Scaling"}
                text={`Scale your team up or down based on project demands without the hassle of long-term commitments. Our staff augmentation solutions ensure you have the right resources at the right time.`}
                icon={
                  <BlurOnIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle2={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"Cost-Effective Solutions"}
                text={`Reduce overhead costs associated with hiring full-time employees while maintaining high-quality output. Our staff augmentation services help you achieve your goals without breaking the budget.`}
                icon={
                  <DvrIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"Seamless Integration"}
                text={`Our augmented staff seamlessly integrates with your existing teams, ensuring smooth collaboration and minimal disruption. We provide professionals who align with your company culture and workflows.`}
                icon={
                  <TabIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle3={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"Expertise Across Technologies"}
                text={`Gain access to professionals with expertise in the latest technologies and tools. Our staff augmentation services ensure your projects are powered by cutting-edge skills and knowledge.`}
                icon={
                  <WindowIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"Faster Time-to-Market"}
                text={`Accelerate project timelines by leveraging our skilled professionals. With staff augmentation, you can meet tight deadlines and deliver high-quality results faster.`}
                icon={
                  <DoubleArrowIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
        />
        <OurProcess
          invert
          step1={"Identify Your Project Needs and Skill Gaps"}
          step1description={
            "We begin by understanding your project requirements and identifying skill gaps within your team. Whether you need developers, designers, or specialists, we help you define the exact talent and expertise required to achieve your goals. Our tailored approach ensures the right fit for your project."
          }
          step2={"Onboard Skilled Professionals Seamlessly"}
          step2description={
            "Once your needs are defined, we quickly onboard highly skilled professionals who integrate seamlessly with your existing team. Our staff augmentation process ensures minimal disruption, allowing you to maintain productivity while scaling your team efficiently."
          }
          step3={"Collaborate and Deliver with Expert Support"}
          step3description={
            "Work alongside our augmented staff to deliver high-quality results on time and within budget. Our professionals bring fresh perspectives and expertise, enabling innovation and problem-solving. With their support, you can tackle complex challenges and achieve your project objectives."
          }
          step4={"Scale Flexibly and Optimize Costs"}
          step4description={
            "Our staff augmentation services provide the flexibility to scale your team up or down based on project demands. This approach helps you optimize costs while maintaining access to top-tier talent. Whether it's a short-term project or long-term support, we ensure your business stays agile and competitive."
          }
        />
        

        <YouWillGet
          title1={"OnDemand Talent"}
          title2={"Team Integration"}
          title3={"CostEffective Scaling"}
          title4={"Exprert Collaboration"}
          title5={"Flexible Management"}
        />
        <div style={{ display: state.auth.isMobile ? "none" : "block" }}>
          <Collage />
        </div>
        <Stats />

        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
